(() => {
  function refreshJudgeMe(panel) {
    if (!panel?.querySelector('.jdgm-review-widget')) return;

    const refresh = () => {
      if (window.jdgm?.refreshWidgets) window.jdgm.refreshWidgets();
    };

    // Judge.me can load after the theme script, so refresh both now and once
    // its deferred app script has had a chance to initialize.
    requestAnimationFrame(refresh);
    window.setTimeout(refresh, 500);
  }

  function setup(root) {
    if (root.dataset.tabsReady === 'true') return;
    root.dataset.tabsReady = 'true';
    const triggers = [...root.querySelectorAll('[data-tab-trigger]')];
    const panels = [...root.querySelectorAll('[data-tab-panel]')];
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const select = (trigger, allowCollapse = true) => {
      const isMobile = mobileQuery.matches;
      const panel = root.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
      const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
      triggers.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-selected', 'false');
        item.setAttribute('aria-expanded', 'false');
      });
      panels.forEach((item) => { item.hidden = true; });
      if (isMobile && wasOpen && allowCollapse) return;
      trigger.classList.add('is-active');
      trigger.setAttribute('aria-selected', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.hidden = false;
        refreshJudgeMe(panel);
      }
    };

    triggers.forEach((trigger) => trigger.addEventListener('click', () => select(trigger)));
    root.addEventListener('product-reviews:show', () => {
      const panel = root.querySelector('[data-product-reviews-tab]');
      const trigger = triggers.find((item) => item.getAttribute('aria-controls') === panel?.id);
      if (trigger) select(trigger, false);
    });
    root.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || mobileQuery.matches) return;
      const index = triggers.indexOf(document.activeElement);
      if (index < 0) return;
      event.preventDefault();
      const next = event.key === 'ArrowRight' ? (index + 1) % triggers.length : (index - 1 + triggers.length) % triggers.length;
      triggers[next].focus();
      select(triggers[next]);
    });

    if (mobileQuery.matches) {
      triggers.forEach((trigger) => {
        trigger.classList.remove('is-active');
        trigger.setAttribute('aria-selected', 'false');
        trigger.setAttribute('aria-expanded', 'false');
      });
      panels.forEach((panel) => { panel.hidden = true; });
    }
  }
  document.querySelectorAll('[data-product-tabs]').forEach(setup);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-product-tabs]').forEach(setup));
})();
